export default __webpack_public_path__ + "static/media/blank-ok.9dab192f.svg";